const ChooseIntent = ({
	intents,
	intent,
	setIntent,
}) => {

	if (intent) return null;

	return <div className="service-modal__step-two">
		<p className="service-modal__text">and I want...</p>
		<div className="services-modal__grid">
			{intents.map(i => (
				<button key={i.slug} className="services-modal__grid-item services-modal__intent" onClick={() => setIntent(i)}>
					<h3 className="service-modal__title">{i.name}</h3>
					<p className="service-modal__description">{i.description} </p>
				</button>
			))}
		</div>
		<div className="services-modal__intent-instruction">
			<svg width="35" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path opacity="0.2" d="M12 4C7.59 4 4 7.59 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z" fill="#8055F1"/>
				<path d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#2B0950"/>
			</svg>
			<p>To begin seeing results that may suit your needs, select one of the suggestions above.</p>
		</div>
	</div>;
}
 
export default ChooseIntent;